import { fetchWithToken } from '@utils/api';
import { API_URL } from '@data/constants';

export const ROLE_ADMIN = 'ADMIN';
export const ROLE_ASSESSOR = 'ASSESSOR';
export const ROLE_VOLUNTEER = 'VOLUNTEER';

import type { UserProfile } from './profiles';

export interface User {
  id: number;
  emailAddress: string;
  acbidNickname: string;
  role: typeof ROLE_ADMIN | typeof ROLE_ASSESSOR | typeof ROLE_VOLUNTEER;
  profile: UserProfile | null;
}

export async function fetchUser(): Promise<User> {
  const response = await fetchWithToken(`${API_URL}/api/users/me`);

  if (!response.ok) {
    throw new Error('Error fetching user');
  }

  const { data } = await response.json() as { data:{ id: number, emailAddress: string, role: typeof ROLE_VOLUNTEER | typeof ROLE_ASSESSOR, profile: null|UserProfile, acbidNickname: string } };

  return {
    id: data.id,
    emailAddress: data.emailAddress,
    acbidNickname: data.acbidNickname,
    role: data.role,
    profile: data.profile
  };
}

export async function getUser(userId: number): Promise<User> {
  const response = await fetchWithToken(`${API_URL}/api/users/${userId}`);

  if (!response.ok) {
    throw new Error('Error fetching user');
  }

  const { data } = await response.json() as { data:{ id: number, emailAddress: string, role: typeof ROLE_VOLUNTEER | typeof ROLE_ASSESSOR, profile: null|UserProfile, acbidNickname: string } };

  return {
    id: data.id,
    emailAddress: data.emailAddress,
    acbidNickname: data.acbidNickname,
    role: data.role,
    profile: data.profile
  };
}

export async function getTotalUsers() {
  const response = await fetchWithToken(`${API_URL}/api/users/total`);

  if (!response.ok) {
    throw new Error('Error fetching total users');
  }

  const { data } = await response.json() as { data: { totalUsers: number } };

  return data;
}